import React, { useState, useEffect } from 'react'
import api from '../components/api'
import axios from 'axios'


const Modal = (props) => {

    //var linkAPI = 'http://172.16.1.253:3700/'
    var linkAPI = 'https://cdn.hospitaissaudaveis.org/'

    var slider_id = props.slider_id

    var [ordem, setOrdem] = useState('')
    var [texto1, setTexto1] = useState('')
    var [texto2, setTexto2] = useState('')
    var [texto3, setTexto3] = useState('')

    var [link, setLink] = useState('')

    var [imagem, setImagem] = useState('')
    var [file, setFile] = useState('')
    var [publicado, setPublicado] = useState(true)


    function salvar() {
        
        if (ordem == '') {

            window.toastr.error('Por favor, informe a <b>Ordem</b>')
            return false

        }

        /*
        if (texto1 == '') {

            window.toastr.error('Por favor, informe o <b>Texto #1</b>')
            return false

        }

        if (texto2 == '') {

            window.toastr.error('Por favor, informe o <b>Texto #2</b>')
            return false

        }
        */


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {



                    const formData = new FormData();
                    const imagefile = document.querySelector("#fileImg");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagem", imagefile.files[0]);
                    formData.append("texto1", texto1); // string junto ao formData.
                    formData.append("texto2", texto2)
                    formData.append("texto3", texto3)
                    formData.append("publicado", publicado)
                    formData.append("ordem", ordem)
                    formData.append("link", link)

                    //console.log(formData)
                    //return false


                    if (!isNaN(slider_id)) {

                        //console.log(`${linkAPI}slider/${slider_id}`)
                        //return false

                        axios.put(`${linkAPI}slider/${slider_id}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            //console.log(response)

                            window.$("#modalCarrosel").modal('hide');
                            
        
                            window.toastr.success('Salvo com sucesso!')

                            props.listaCarrossel()



                        }).catch((err) => {

                            console.log(err.response)

                        })



                    } else {

                        //console.log('inclui')
                        //return false

                        axios.post(linkAPI + 'slider/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            //console.log(response)

                            window.$("#modalCarrosel").modal('hide');
                            
        
                            window.toastr.success('Salvo com sucesso!')

                            props.listaCarrossel()



                        }).catch((err) => {

                            console.log(err.response)

                        })


                    }

                    
                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        
    }


    function apagar() {

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {


                    api.delete(`slider/${slider_id}`).then((result) => {

                        console.log(result.data)
                        window.$("#modalCarrosel").modal('hide');
                        window.toastr.success('Apagado com sucesso!')
                        props.listaCarrossel()

                    }).catch((err) => {

                        console.log(err)

                    })

                        
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });
    }


    function limpaCampos() {


        setTexto1('')
        setTexto2('')
        setTexto3('')
        setOrdem('')
        setPublicado(true)
        setLink('')
        setImagem('')
        setFile('')

    }


    async function carrega() {


        if (slider_id) {

            api.get(`sliderListaUm/${slider_id}`).then((result) => {

                console.log(result.data)
                
                var data = result.data[0]

                if (data) {

                    setOrdem(data.ordem)
                    setPublicado(data.publicado)
                    setTexto1(data.texto1)
                    setTexto2(data.texto2)
                    setTexto3(data.texto3)
                    setLink(data.link)
                    setImagem(data.foto)                    


                }

            }).catch((err) => {

                console.log(err.response)

            })


        }


    }


    useEffect(() => {

        limpaCampos()
        carrega()

    }, [slider_id])


    return (
        <div>


                <div className="modal fade" id="modalCarrosel" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Slider página inicial</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">
                                        

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Ordem</label>
                                                <input type="text" className="form-control" value={ordem} onChange={event => setOrdem(event.target.value)} />

                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label>Publicar</label>
                                                <select className="form-control" value={publicado} onChange={event => setPublicado(event.target.value)} >

                                                    <option value={true}>Sim</option>
                                                    <option value={false}>N&atilde;o</option>

                                                </select>

                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-12" style={{ display: 'none'}}>
                                            <div class="form-group">
                                                <label>Texto #1</label>
                                                <input type="text" className="form-control" value={texto1} onChange={event => setTexto1(event.target.value)} />

                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-12" style={{ display: 'none'}}>
                                            <div class="form-group">
                                                <label>Texto #2</label>
                                                <input type="text" className="form-control" value={texto2} onChange={event => setTexto2(event.target.value)} />

                                                                
                                            </div>
                                        </div>
                                        <div class="col-md-12" style={{ display: 'none'}}>
                                            <div class="form-group">
                                                <label>Texto #3</label>
                                                <input type="text" className="form-control" value={texto3} onChange={event => setTexto3(event.target.value)} />

                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Link (opcional)</label>
                                                <input type="text" className="form-control" value={link} onChange={event => setLink(event.target.value)} />

                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Imagem</label>
                                                <input type="text" className="form-control" placeholder="" value={imagem} readOnly style={{cursor: imagem ? 'pointer' : 'auto' }} onClick={() => imagem ? window.open(`${linkAPI}uploads/slider/${imagem}`) : ''}/>
                                                
                                                                
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Upload nova imagem</label>
                                                <input type="file" className="form-control" id="fileImg" value={file} onChange={event => setFile(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                      


                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button type="button" className="btn btn-danger" onClick={() => apagar()} style={{ display: slider_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvar()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

        </div>
    )

}

export default Modal